import Select from 'react-select';
import { useState, useEffect } from 'react';
import './reclamo.css';

const estados = {
  901: 'SIN CARGAR',
  902: 'PEND. APROBACION',
  903: 'DEVOLUCIÓN',
  905: 'REINGRESO',
  904: 'CARGADA',
};

const colores = {
  901: { bg: '#cccccc', color: '#FFFFFF' },
  902: { bg: '#82C1F1', color: '#1631B9' },
  903: { bg: '#FBAF84', color: '#FFFFFF' },
  905: { bg: '#8E44AD', color: '#FFFFFF' },
  904: { bg: '#82F1CD', color: '#29AC8D' },
};
const opciones = Object.entries(estados)
  .map(([value, label]) => ({
    value: Number(value),
    label,
    ...colores[value],
  }))
  .sort((a, b) => {
    const orden = [901, 902, 903, 905, 904];
    return orden.indexOf(a.value) - orden.indexOf(b.value);
  });
const getOptionTextColor = (value, theme) => {
  const isDark = theme !== 1;
  switch (value) {
    case 901: // SIN CARGAR
      return isDark ? '#a1a1aa' : '#707070';
    case 902: // PEND. APROBACION
      return isDark ? '#82C1F1' : '#1631B9';
    case 903: // DEVOLUCIÓN
      return isDark ? '#fbaf84' : '#d97706';
    case 905: // REINGRESO
      return isDark ? '#c084fc' : '#8e44ad';
    case 904: // CARGADA
      return isDark ? '#82f1cd' : '#29ac8d';
    default:
      return isDark ? '#ffffff' : '#000000';
  }
};

export function EstadosDocs({ estado, onChange, cookies, theme }) {
  const [valor, setValor] = useState(opciones.find(opt => opt.value === estado));
  useEffect(() => {
    const nueva = opciones.find(opt => opt.value === estado);
    if (nueva) setValor(nueva);
  }, [estado]);
  const handleChange = selectedOption => {
    setValor(selectedOption);
    onChange?.(selectedOption.value);
  };
  const customStyles = {
    control: styles => ({
      ...styles,
      backgroundColor: valor?.bg,
      color: valor?.color + ' !important',
      minHeight: '20px',
      height: '20px',
      borderRadius: '8px',
      border: 'none',
      boxShadow: 'none',
      cursor: 'pointer',
      fontSize: '12px',
      fontWeight: '400',
      fontFamily: 'Poppins, sans-serif',
      width: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
    }),
    singleValue: styles => ({
      ...styles,
      color: valor?.color + ' !important',
      margin: 0,
      padding: 0,
      fontWeight: '600',
      lineHeight: '20px',
    }),
    dropdownIndicator: styles => ({
      ...styles,
      color: valor?.color + ' !important',
      padding: '0 6px',
      display: 'flex',
      alignItems: 'center',
    }),
    indicatorSeparator: styles => ({
      ...styles,
      backgroundColor: 'transparent',
    }),
    option: (styles, { data, isFocused, isSelected }) => {
      const isDark = theme !== 1;
      let bg = 'transparent';
      if (isSelected) {
        bg = isDark ? '#3f3f46' : '#cbd5e1';
      } else if (isFocused) {
        bg = isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)';
      }
      return {
        ...styles,
        backgroundColor: bg + ' !important',
        color: getOptionTextColor(data.value, theme) + ' !important',
        fontWeight: '600',
        fontFamily: 'Poppins, sans-serif',
        cursor: 'pointer',
        padding: '6px 12px',
        fontSize: '12px',
      };
    },
    menu: styles => ({
      ...styles,
      borderRadius: '12px',
      overflow: 'hidden',
      fontFamily: 'Poppins, sans-serif',
      fontWeight: '600',
      fontSize: '12px',
      width: 'max-content',
      minWidth: '110px',
      backgroundColor: (theme === 1 ? '#ffffff' : '#27272a') + ' !important',
      border: (theme === 1 ? '1px solid #cbd5e1' : '1px solid #3f3f46') + ' !important',
    }),
    container: styles => ({
      ...styles,
      display: 'inline-block',
    }),
  };
  return <Select value={valor} isDisabled={cookies?.user?.titulo === 'lector'} onChange={handleChange} options={opciones} styles={customStyles} isSearchable={false} />;
}
